<template>
  <div>
    <h3 v-if="title">{{ title }}</h3>
    <div>
      <button
        v-for="value in values"
        :key="value.value"
        @click="toggle(value)"
        :class="['filter', isSelected(value) ? 'selected' : undefined]"
        :aria-label="value.label"
      >
        <slot v-bind:label="value.label" v-bind:value="value.value">{{
          value.label
        }}</slot>
      </button>
    </div>
  </div>
</template>
<script>
export default {
  name: "Filter",
  props: {
    title: String,
    values: Array,
    multiple: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      selected: [],
    };
  },
  methods: {
    toggle(value) {
      if (this.isSelected(value)) {
        this.selected = this.selected.filter(
          (selectedValue) => selectedValue != value.value
        );
      } else {
        if (this.multiple) {
          this.selected = [...this.selected, value.value];
        } else {
          this.selected = [value.value];
        }
      }
      this.$emit("change", this.multiple ? this.selected : this.selected[0]);
    },
    isSelected(value) {
      return this.selected.includes(value.value);
    },
  },
};
</script>
<style>
.filter {
  background-color: dimgray;
  border: 1px solid lavender;
  color: hsl(224.2, 33.3%, 88.8%);
  font-weight: bold;
  padding: 1rem;
  border-radius: 5%;
}

.filter:hover {
  background-color: darkgray;
}

.filter.selected {
  background-color: steelblue;
}
</style>
